import React, { useRef } from "react";
import clsx from "clsx";
import { Button, Form, MenuItem, SelectField } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { isEmpty, isFunction, refIsRequiredError } from "@util/utils";
import { useMemberProfileApi } from "@apis/useMemberProfileApi";

const HundredTShirtSizeDialog = React.forwardRef((props, ref) => {
	const { className, open, sourceData, onClose, refresh } = props;
	if (!open) return null;
	const { memberID, hundredTShirtSize, options } = sourceData || {};

	const { postMemberProfileHundredTShirtApi } = useMemberProfileApi();

	const hundredTShirtSizeRef = useRef(null);

	const doMemberProfileHundredTShirtApi = async (memberID, params) => {
		let resp = await postMemberProfileHundredTShirtApi(memberID, params);
		if (resp) {
			const { hundredTShirtSize } = resp;
			isFunction(refresh) && refresh(hundredTShirtSize);
			isFunction(onClose) && onClose();
		}
	};
	const handleSubmit = () => {
		let isError = refIsRequiredError(hundredTShirtSizeRef);
		if (!isError) {
			let params = {
				hundredTShirtSize: hundredTShirtSizeRef.current && hundredTShirtSizeRef.current.getResult(),
			};

			doMemberProfileHundredTShirtApi(memberID, params);
		}
	};

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-40rem", component: Form }} onSubmit={handleSubmit} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>百Ｔ尺寸</GradientColorHeader>
			<DialogContent>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<SelectField label="百Ｔ尺寸" key={hundredTShirtSize} defaultValue={hundredTShirtSize} ref={hundredTShirtSizeRef} displayEmpty fullWidth required>
							{!isEmpty(options) &&
								options
									.filter(item => item || !item.disabled)
									.map(item => (
										<MenuItem key={item.value} value={item.value}>
											{item.text}
										</MenuItem>
									))}
						</SelectField>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button type={"submit"} variant="contained">
					確認送出
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default HundredTShirtSizeDialog;
